import { LineHeights } from './interfaces'

// values should be interpreted as rem
// rem base: 1rem = 16px

export const lineHeights: LineHeights = {
  xs: '0.75rem',
  s: '1rem',
  m: '1.25rem',
  l: '1.75rem',
  xl: '2.5rem',
}
